import axiosInstance from "../services/secureApi";

export const requestPickupApi = async (orderId) => {
  try {
    const response = await axiosInstance.post(
      `/admin/orders/${orderId}/request-pickup`
    );

    return response.data;
  } catch (error) {
    console.error("Pickup Request Error:", error.response?.data);
    throw error.response?.data || error;
  }
};